/* eslint-disable @typescript-eslint/no-empty-function */
import qs from 'query-string';
import { createContext, useState } from 'react';
import { Localization } from 'static/localization/localization';

export interface ICtxApp {
    language: string;
    mobileMessageShown?: boolean;
    minuteEditor?: boolean;
    setMobileMessageShown: (mobileMessageShown: boolean) => void;
    setMinuteEditor: (minuteEditor: boolean) => void;
    setLanguage: (language: string) => void;
}

export const CtxApp = createContext<ICtxApp>(null);

export const AppStateProvider = ({ children }: { children: React.ReactNode }) => {
    const params = qs.parse(window.location.search) as {
        lang?: string;
    };

    const [mobileMessageShown, setMobileMessageShown] = useState(false);
    const [minuteEditor, setMinuteEditor] = useState(false);
    const [language, setLanguage] = useState(params.lang ?? Localization.getLanguage() ?? 'en');

    return (
        <CtxApp.Provider
            value={{
                mobileMessageShown,
                setMobileMessageShown,
                minuteEditor,
                setMinuteEditor,
                language,
                setLanguage
            }}
        >
            {children}
        </CtxApp.Provider>
    );
};
